const request = {
    invalid_input: '输入无效。{{details}}',
    general: '发生请求错误。',
    range_not_satisfiable: '范围不满足。',
    feature_not_supported: '当前环境不支持此功能。',
};
export default Object.freeze(request);
